<template>
    <v-list>
        <v-subheader class="headline primary--text">Basket</v-subheader>
        <v-list-item
            v-for="(product,index) in basketProducts"
            :key="index"
        >
            <v-list-item-icon>
                <router-link
                        :to="{ name: 'product', params: {slug: product.slug} }"
                >
                    <v-img
                            v-if="product.image"
                            alt="product.name"
                            :src="require('@/assets/' + product.image)"
                            aspect-ratio="1.6"
                            min-width="100"
                    ></v-img>
                </router-link>
            </v-list-item-icon>

            <v-list-item-content>

                <v-list-item-title class="subtitle-2">
                    <router-link
                        :to="{ name: 'product', params: {slug: product.slug} }"
                >{{ product.name }}</router-link>
                </v-list-item-title>
                <v-list-item-subtitle class="body-2">{{ brand === 'neotag' ? '€' : '£'}}{{ product.price }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="product.dependant">{{ product.dependant.name }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
                <v-btn
                        icon
                        @click="removeFromBasket(index)"
                >
                    <v-icon
                            large
                            color="grey lighten-1"
                    >delete</v-icon>
                </v-btn>
            </v-list-item-action>

        </v-list-item>
        <p class="total subtitle-2 text-right" v-if="basketTotal">{{ $t('Total') }} {{ brand === 'neotag' ? '€' : '£'}}{{ basketTotal }}</p>
        <p class="pl-4 pr-4">
        <v-btn
                rounded
                block
                color="primary"
                elevation="0"
                @click="navigate('basket')"
                class="view-button"
        >
            {{ $t('buttons.View basket') }}
        </v-btn>
        </p>

    </v-list>

</template>

<script>
    import { store } from '../store';
    import {mapActions, mapState} from 'vuex';

    export default {
        name: "Basket",
        mounted () {
            window.scrollTo(0,0);
        },
        computed: {
            ...mapState({
              brand: state => state.brand,
brandName: state => state.brandName
            }),
            basketProducts () {
                console.log(store.getters['basket/products'])
                return store.getters['basket/products']
            },
            basketTotal () {
                return store.getters['basket/productsTotal']
            }
        },
        methods: {
            ...mapActions('basket', ['remove', 'clear']),
            removeFromBasket(index) {
                return this.remove({index}).then(() => {
                    console.log('removed')
                    //store.dispatch('alert/success', 'Added to basket', { root: true });
                })
            },
            clearBasket() {
                return this.clear().then(() => {
                    console.log('cleared')
                    //store.dispatch('alert/success', 'Added to basket', { root: true });
                })
            },
            navigate(routeName) {
                this.$router.push({name: routeName})
            }
        }
    }
</script>

<style scoped>
    .view-button {
        margin: 0;
        padding: 0;
    }
    .total {
        margin-right: 20px;
    }
</style>


